import React, { VFC } from 'react';
import styled from 'styled-components';
import { HEADER_MIN_HEIGHT, TOOLBAR_SM_MIN_HEIGHT } from '../utils';

const StyledDummyHeader = styled.div<{ isPC: boolean }>`
  height: ${({ isPC }) => (isPC ? HEADER_MIN_HEIGHT : TOOLBAR_SM_MIN_HEIGHT)}px;
`;

interface Props {
  isPC: boolean;
}
const DummyHeader: VFC<Props> = ({ isPC }: Props) => {
  return <StyledDummyHeader isPC={isPC} />;
};

export default DummyHeader;
